import React from "react"
import { useTranslation } from "react-i18next"

import RmTableRow from "./RmTableRow"
import classes from "./RmTable.module.scss"

const RmTable = (props) => {
  const { ordersForDispatch, setOrdersForDispatch } = props

  const [t] = useTranslation()

  return (
    <div className={classes["container"]}>
      <table className={classes["table"]}>
        <thead>
          <tr>
            <th>{t("ردیف")}</th>
            <th>{t("نام_مشتری")}</th>
            <th>{t("شماره_سفارش")}</th>
            <th>{t("تاریخ_ثبت_سفارش")}</th>
            <th>{t("تاریخ_تایید_سفارش")}</th>
            <th>{t("محصولات_خریداری_شده")}</th>
            <th>{t("گزارش_وضعیت_انبار")}</th>
            <th>{t("اطلاعات طریق سفارش")}</th>
            <th>{t("مجموع")}</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {ordersForDispatch.map((orderForDispatch, eoIndex) =>
            <RmTableRow
              key={orderForDispatch._id}
              eoIndex={eoIndex}
              orderForDispatch={orderForDispatch}
              setOrdersForDispatch={setOrdersForDispatch}
            />
          )}
        </tbody>
      </table>
    </div>
  )
}

export default RmTable